module.exports = __webpack_public_path__ + "media/images/new-ui-images/validate-932c8606cfbf371b88e1e9b33671eb88.svg";